import { API, axiosInstance } from "lib";

// chart of account
export const getUsablityList = (data = {}) => {
    return axiosInstance
        .post(API.GET_USABLITY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};

export const getWalletTransactionList = (data = {}) => {
    return axiosInstance
        .post(API.GET_WALLET_TRANSACTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};


export const addBalanceApi = (data = {}) => {
    return axiosInstance
        .post(API.ADD_BALANCE_WALLET, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};

export const addBalanceVerifyApi = (data = {}) => {
    return axiosInstance
        .post(API.ADD_BALANCE_VERIFY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};

